import { Select } from "antd";
import React from "react";

// TODO (david.taylor): This component uses antd because the only place it's used is stuck on antd (uses a form).
// We should update this to use rivet-ui when UserProfile.tsx gets moved to use rivet.

interface AxonConnectOverrideSelectionProps {
  onChange: (value: boolean) => void;
  currentSelection: boolean;
  disabled?: boolean;
}

const AxonConnectOverrideSelection = ({
  onChange,
  disabled,
  currentSelection,
}: AxonConnectOverrideSelectionProps) => {
  return (
    <div className="flex items-center gap-2">
      <Select
        className="w-32"
        value={currentSelection}
        disabled={disabled}
        onChange={value => {
          onChange(value);
        }}
      >
        <Select.Option value={true}>Enabled</Select.Option>
        <Select.Option value={false}>
          {/* TODO (david.taylor): when rivet typography has danger styling use that*/}
          <span className="ant-typography ant-typography-danger">Disabled</span>
        </Select.Option>
      </Select>
    </div>
  );
};

export default AxonConnectOverrideSelection;
